<template lang="pug">
.inside-padding.container-new-brand
  h3.capitalize Activar Nueva Marca

  form(@submit.prevent="")
    .input-container
      input.input(v-model="name" type="text" autocomplete="ño" required)
      label.label(:class="{ show: name }") Nombre de la Nueva Marca
    .input-container.arrow
      label.label(:class="{ show: copyBrand }") Copiar Datos de
      select.select(v-model="copyBrand" autocomplete="ño")
        option(value="")
        option(v-for="brand in brands" :value="brand") {{ capitalize(brand) }}
    shActionButton(:isForm="true" text="Activar" textRunning="Activando" :action="createNewBrand" textConfirmation="Se va a activar una nueva marca.")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import gqlBrand from '@/graphql/brand'
import gql from '@my/graphql'
import modals from '@my/store/modals'

export default {
  name: 'NewBrand',

  mixins: [mForm, mFilters],

  data () {
    return {
      name: '',
      copyBrand: ''
    }
  },

  methods: {
    async createNewBrand () {
      const mutation = gqlBrand.NEW
      const response = await gql.mutate(mutation, { name: this.name, copyBrand: this.copyBrand })

      if (response) modals.showMessage({ message: `La marca ${this.capitalize(this.name)} se ha activado correctamente` })
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    }
  }
}
</script>

<style lang="stylus" scoped>
.container-new-brand
  padding-bottom 2em
</style>



// WEBPACK FOOTER //
// src/components/pages/others/ActiveBrand.vue